import { Link } from 'react-router-dom'

const COL_PRODUIT = [
  { label: 'Comparatif',  to: '/comparatif' },
  { label: 'Tarifs',      to: '/tarifs' },
  { label: 'FAQ',         to: '/faq' },
]

const COL_RESSOURCES = [
  { label: 'Blog',              to: '/blog' },
  { label: 'Fonctionnalités',   to: '/fonctionnalites' },
  { label: 'Pour les profs',    to: '/pour-les-profs' },
]

const COL_LEGAL = [
  { label: 'Mentions légales',         to: '/mentions-legales' },
  { label: 'Politique de confidentialité', to: '/confidentialite' },
  { label: 'CGU',                      to: '/cgu' },
]

function FooterCol({ title, links }) {
  return (
    <div>
      <h3 className="text-sm font-medium text-slate-400 uppercase tracking-wider mb-4">{title}</h3>
      <ul className="space-y-2.5">
        {links.map(link => (
          <li key={link.to}>
            {link.soon ? (
              <span className="text-slate-500 text-sm flex items-center gap-1.5">
                {link.label}
                <span className="text-xs bg-slate-700 text-slate-400 px-1.5 py-0.5 rounded">bientôt</span>
              </span>
            ) : (
              <Link
                to={link.to}
                className="text-slate-400 hover:text-white text-sm transition-colors"
              >
                {link.label}
              </Link>
            )}
          </li>
        ))}
      </ul>
    </div>
  )
}

export default function Footer() {
  return (
    <footer className="bg-kart-night text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">

          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2.5 mb-4" aria-label="KartQuiz">
              <img src="/android-chrome-192x192.png" alt="KartQuiz" className="w-9 h-9 object-contain" />
              <span className="font-brand text-xl">KartQuiz</span>
            </Link>
            <p className="text-slate-400 text-sm leading-relaxed">
              KartQuiz, le quiz ultra fun qui met ta classe en pole position
            </p>
            <p className="text-slate-500 text-xs mt-4">
              Un produit <span className="text-slate-400 font-medium">BCOMING.Digital</span>
            </p>
          </div>

          <FooterCol title="Produit"    links={COL_PRODUIT} />
          <FooterCol title="Ressources" links={COL_RESSOURCES} />
          <FooterCol title="Légal"      links={COL_LEGAL} />
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-slate-500 text-sm">
            © {new Date().getFullYear()} BCOMING.Digital — SIRET 877 976 571 00019
          </p>
          <p className="text-slate-500 text-sm">
            Fait avec ❤️ à Lyon
          </p>
        </div>
      </div>
    </footer>
  )
}
